/**
 * IFC Header generator (STEP-21)
 * Keeps header logic isolated from entity creation.
 */

function buildTimestampUtc(now: Date): string {
  // Prior behavior: 20260108T132455Z (no dashes/colons, drop milliseconds)
  return now.toISOString().replace(/[-:]/g, "").split(".")[0];
}

export function generateHeader(): string {
  const now = new Date();
  const timestamp = buildTimestampUtc(now);
  const filename = `export_${timestamp}.ifc`;

  return `ISO-10303-21;
HEADER;
FILE_DESCRIPTION(('','ExchangeRequirement[Architecture, Structural, BuildingService]'),'2;1');
FILE_NAME('${filename}','${now.toISOString()}',('User'),('Organization'),'NiceConnect IFC Export','$','$');
FILE_SCHEMA(('IFC4X3_ADD2'));
ENDSEC;

DATA;
`;
}
